import React from 'react';
import { Breadcrumbs } from 'ha/components/Breadcrumbs';

import { useListingBreadcrumbs } from './useListingBreadcrumbs';

const ListingBreadcrumbs: React.FC = () => {
  const { hasError, breadcrumbs } = useListingBreadcrumbs();

  if (hasError) {
    return null;
  }

  return <Breadcrumbs breadcrumbs={breadcrumbs} />;
};

export { ListingBreadcrumbs };
